import * as React from "react";

import { INote } from "../types/INote";
import { Note } from "./note.component";
import { useNoteListStyles } from "./notes.styles";

export const NoteList = React.memo((props: { baseId: string; notes: INote[] }) => {
    const extendedId = `${props.baseId}NoteList`;
    const classes = useNoteListStyles({});
    return (
        <div className={classes.root} id={extendedId}>
            {props.notes.map((n, i) => (
                <Note baseId={`${extendedId}Note-${i}`} note={n} key={`${extendedId}Note-${i}`} />
            ))}
        </div>
    );
});
